const routes =  [
    '/admin/login',
    '/admin/forgot-password',
    '/login',
    '/rsvp/:uuid',
    'privacy',
    '/user/campaign/unsubscribe',
    '/rsvpi',
    '/admin/reset-password/:token'
]

export default routes